import axios from 'axios';

export const getConfig = () => {
  return axios.get('/user/configuration').then((res) => res.data.data);
};

export const updateConfig = (payload) => {
  return axios.put('/user/configuration', payload).then((res) => res.data);
};
